import React from 'react';
import { Row, Col } from './grid';
import {
  Paragraph, List, Heading3, LinkStyled,
} from './typography';
import { Image } from './Image';

// Array of content from the content already in export default () => (
const content = [
  {
    title: 'Drinks med Serena Vino Frizzante',
    drinks: [
      {
        image: 'drinks.hyldeblomst-spritzer.png',
        title: 'Hyldeblomst Spritz',
        list: [<React.Fragment>4 dele <LinkStyled to="/sodavand/frem-sodavand">Frem hyldeblomst sodavand</LinkStyled></React.Fragment>, '1 del gin', 'Pres limesaft fra en limebåd', 'Top op med Serena Vino Frizzante', 'Isterninger', 'Limebåd og lidt mynteblade'],
      },
      {
        image: 'drinks.mojito-spritz.png',
        title: 'Mojito Spritz',
        list: ['1 del lys rom', '8-12 mynteblade', '½ lime i både', 'Knust is', '1 del danskvand', 'Rørsukker efter behov', 'Top op med Serena Vino Frizzante.'],
      },
      {
        image: 'drinks.GT-spritz.png',
        title: 'Gin Tonic Spritz',
        list: ['4 dele tonic sodavand', '1 del Gin', 'Pres en citronbåd', 'Isterninger', 'Top op med Serena Vino Frizzante', 'En skive citron og en agurkestav'],
      },
      {
        image: 'drinks.pink-spritz.png',
        title: 'Pink Spritz',
        list: [<React.Fragment>4 dele <LinkStyled to="/sodavand/frem-sodavand">Frem Grape Light</LinkStyled> sodavand</React.Fragment>, '1 del vodka', 'Isterninger', 'Top op med Serena Vino Frizzante', 'En skive lime'],
      },
      {
        image: 'drinks.aperol-spritz.png',
        title: 'Aperol Spritz',
        list: ['2 dele Aperol', '1 del danskvand', 'Top med Serena Vino Frizzante', 'Isterninger', '½ appelsinskive'],
      },
      {
        image: 'drinks.kir-royal.png',
        title: 'Vino Frizzante Kir Royal',
        list: ['1 del Crème de cassis', 'Top med Serena Vino Frizzante', 'Et par tranebær'],
      },
    ],
  },
];
export default () => (
  // Map the content array to the JSX
  content.map(item => (
    <Row>
      <Col xs={12}>
        <Heading3>
          {item.title}
        </Heading3>
      </Col>
      {item.drinks.map(drink => (
        <Col xs={12} sm={6} md={6} lg={4} xl={4} xxl={2} textCenter>
          <Paragraph>
            <Image name={drink.image} alt={drink.title} maxHeight="185px" imageHeight="185px" />
          </Paragraph>
          <Paragraph bold fontSize="14px">
            {drink.title}:
          </Paragraph>
          <List borderGroup>
            {drink.list.map(listItem => (
              <li>{listItem}</li>
            ))}
          </List>
        </Col>
      ))}
    </Row>
  ))
);
